import { render, staticRenderFns } from "./editSetting.vue?vue&type=template&id=75d04ae8&"
import script from "./editSetting.vue?vue&type=script&lang=js&"
export * from "./editSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports